



















































































































































































import { computed, defineComponent, ref } from '@vue/composition-api';
import authMixin from '@/mixins/auth';

import {
  useDeleteBankPaymentInstruction,
  useFetchBankPaymentInstructions
} from '@/composable/bank';
import { IBankPaymentInstruction } from '@/models';

import NoDataAvailablePlaceholder from '@/components/common/NoDataAvailablePlaceholder.vue';
import PaymentInstructionListItem from './PaymentInstructionListItem.vue';
import PaymentInstructionFormDialog from './PaymentInstructionDialog.vue';
import PaymentInstructionPropertyFormDialog from './PaymentInstructionPropertyDialog.vue';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';

export default defineComponent({
  name: 'PaymentInstructionList',
  components: {
    ConfirmationDialog,
    NoDataAvailablePlaceholder,
    PaymentInstructionListItem,
    PaymentInstructionFormDialog,
    PaymentInstructionPropertyFormDialog,
    ErrorAlert
  },
  mixins: [authMixin],
  props: {
    bank: {
      type: Object,
      default: null
    }
  },
  setup(props) {
    const dialog = ref(false);
    const selectedPaymentInstruction = ref<IBankPaymentInstruction | null>(
      null
    );

    function openPaymentInstructionFormDialog(
      paymentInstruction?: IBankPaymentInstruction
    ) {
      selectedPaymentInstruction.value = paymentInstruction ?? null;
      dialog.value = true;
    }

    const deleteDialog = ref(false);
    function openPaymentInstructionDeleteDialog(
      paymentInstruction: IBankPaymentInstruction
    ) {
      selectedPaymentInstruction.value = paymentInstruction;
      deleteDialog.value = true;
    }

    const currentBankId = computed(() => props.bank.id);

    const {
      isLoading: deleteInProgress,
      error: deleteError,
      mutate: deletePaymentInstruction
    } = useDeleteBankPaymentInstruction();

    function removePaymentInstruction(
      paymentInstruction: IBankPaymentInstruction
    ) {
      deletePaymentInstruction(paymentInstruction.id!, {
        onSuccess: () => {
          closeDeleteDialog();
        }
      });
    }

    function closeDeleteDialog() {
      deleteDialog.value = false;
      selectedPaymentInstruction.value = null;
    }

    const {
      isLoading: loading,
      paymentInstructions,
      error
    } = useFetchBankPaymentInstructions(currentBankId);

    function clearErrors() {
      deleteError.value = null;
      error.value = null;
    }

    const propertyDialog = ref(false);
    function openPaymentInstructionPropertyFormDialog(
      paymentInstruction?: IBankPaymentInstruction
    ) {
      selectedPaymentInstruction.value = paymentInstruction ?? null;
      propertyDialog.value = true;
    }

    return {
      propertyDialog,
      currentBankId,
      loading,
      dialog,
      deleteDialog,
      selectedPaymentInstruction,
      paymentInstructions,
      error,
      deleteError,
      deleteInProgress,
      openPaymentInstructionFormDialog,
      openPaymentInstructionDeleteDialog,
      openPaymentInstructionPropertyFormDialog,
      closeDeleteDialog,
      removePaymentInstruction,
      clearErrors
    };
  }
});
